export const addonList =  [
    {
      name: 'AppDynamics',
      url: 'https://docs.oobeya.io/integrations',
      show: false
    },
    {
      name: 'AzureDevops',
      url: 'https://docs.oobeya.io/integrations/scm-addons/azure-devops-integration',
      show: true
    },
    {
      name: 'Bitbucket',
      url: 'https://docs.oobeya.io/integrations/scm-addons/bitbucket-server-integration',
      show: true
    },
    {
      name: 'BitbucketCloud',
      url: 'https://docs.oobeya.io/integrations/scm-addons/bitbucket-cloud-integration',
      show: true
    },
    {
      name: 'Dynatrace',
      url: 'https://docs.oobeya.io/integrations',
      show: false
    },
    {
      name: 'ElasticApm',
      url: 'https://docs.oobeya.io/integrations',
      show: false
    },
    {
      name: 'Fortify',
      url: 'https://docs.oobeya.io/integrations',
      show: false
    },
    {
      name: 'SonarCloud',
      url: 'https://docs.oobeya.io/integrations',
      show: false
    },
    {
      name: 'GitHub',
      url: 'https://docs.oobeya.io/integrations/scm-addons/github-integrations',
      show: true
    },
    {
      name: 'GitLab',
      url: 'https://docs.oobeya.io/integrations/scm-addons/gitlab-addon',
      show: true
    },
    {
    name: 'GithubEnterprise',
    url: 'https://docs.oobeya.io/integrations/scm-addons/github-enterprise-integration',
    show: true
    },
    {
      name: 'Jenkins',
      url: 'https://docs.oobeya.io/integrations/scm-addons/jenkins-integration',
      show: true
    },
    {
      name: 'Jira',
      url: 'https://docs.oobeya.io/integrations/project-management-addons/jira-cloud-integration',
      serverUrl: 'https://docs.oobeya.io/integrations/project-management-addons/jira-server-integration',
      show: true
    },
    {
      name: 'NewRelic',
      url: 'https://docs.oobeya.io/integrations/apm-monitoring-addons/new-relic-integration',
      show: true
    },
    {
      name: 'Sentry',
      url: 'https://docs.oobeya.io/integrations/apm-monitoring-addons/sentry-integration',
      show: true
    },
    {
      name: 'Sonar',
      url: 'https://docs.oobeya.io/integrations/code-quality-addons/sonarqube-integration',
      show: true
    },
    {
      name: 'Svn',
      url: 'https://docs.oobeya.io/integrations',
      show: false
    },{
      name: 'TestRail',
      url: 'https://docs.oobeya.io/integrations/test-and-qa-addons/testrail-integration',
      show: true
    },
    {
      name: 'Testinium',
      url: 'https://docs.oobeya.io/integrations',
      show: false
    },
    {
      name: 'TestiniumCloud',
      url: 'https://docs.oobeya.io/integrations',
      show: false
    },
    {
      name: 'Zephyr',
      url: 'https://docs.oobeya.io/integrations',
      show: false
    },
    {
    name: 'TeamCity',
    url: 'https://docs.oobeya.io/integrations/scm-addons/teamcity-integration',
    show: true
     },
  {
    name: 'Octopus',
    url: 'https://docs.oobeya.io/integrations/all-integrations/scm-addons/octopus-deploy-integration',
    show: true
  },
     {
     name: 'Veracode',
     url: 'https://docs.oobeya.io/integrations/security-addons/veracode-integration',
     show: true
      },
  {
    name: 'Gitea',
    show: false
  },
  {
    name: 'Azure Application Insights',
    url: 'https://docs.oobeya.io/integrations/all-integrations/apm-monitoring-addons/azure-application-insights-integration',
    show: true
  },

  ]
